import * as React from "react";
import { Message } from "../types";

interface PrintableMessagesProps {
  messages: Array<Message>;
}

class PrintableMessages extends React.Component<PrintableMessagesProps, {}> {
  renderMessage = (message: Message) => {
    return (
      <div key={message.id} className="velaro-printable-message">
        <div>
          <span className="velaro-printable-author">{message.author}</span>
          <span className="velaro-printable-timestamp">
            {message.timestamp.toLocaleTimeString()}
          </span>
        </div>
        <div>
          <span className="velaro-printable-text">{message.text}</span>
        </div>
      </div>
    );
  };

  render() {
    return <div>{this.props.messages.map(this.renderMessage)}</div>;
  }
}

export default PrintableMessages;
